export const ORDERED_GROUPED_STRUCTURE_KEY = 'ORDERED_GROUPED_STRUCTURE'
export const ORDERED_GROUPED_STRUCTURE_HASH_KEY = 'ORDERED_GROUPED_STRUCTURE_HASH'
